module.exports = __webpack_public_path__ + "static/img/img_over3.fb490f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_over3.png
// module id = S/e/
// module chunks = 1